import React from 'react';
import { useEventContext } from '../../context/EventProvider';
import { Layout, News, Photos, Recap, Videos } from './wrapComponents';

const Articles = () => {
  const {wrap_up} = useEventContext();
  const photoAlbumId = wrap_up?.photoAlbumId;
  const recapVideoHeader = wrap_up?.recapVideoHeader;
  const recapVideoId = wrap_up?.recapVideoId;
  const recapVideoProvider = wrap_up?.recapVideoProvider;
  const news = wrap_up?.articles;
  const videos = wrap_up?.videos;

  return (
    <Layout>
      <News news={news} />
      {wrap_up?.videos[0] && <Videos videos={videos} />}
      {recapVideoId && <Recap recapVideoHeader={recapVideoHeader} recapVideoId={recapVideoId} recapVideoProvider={recapVideoProvider} />}
      <Photos album={photoAlbumId} />
    </Layout>
  );
};

export default Articles;
